<template>
  <vxe-modal v-model="visible" :loading="loading" :title="title" type="confirm" width="25%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row style="margin-left: -8%;margin-right: 8%">
        <a-col span="24">
          <a-form-model-item label="用户名">
            <vxe-input v-model="operator.no" disabled prefix-icon="vxe-icon-user" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="旧密码">
            <vxe-password-input v-model="oldPass" placeholder="请输入旧密码" prefix-icon="vxe-icon-lock" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="新密码">
            <vxe-password-input v-model="newPass" placeholder="请输入新密码" prefix-icon="vxe-icon-lock" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="确认新密码">
            <vxe-password-input v-model="newPass2" placeholder="请再次输入新密码" prefix-icon="vxe-icon-lock" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import api from '@/api'
import { post } from '@/api/Api'

export default {
  name: 'PasswordModify',
  props: {
    operator: { type: Object, default: null }
  },
  data() {
    return {
      visible: false,
      loading: false,
      oldPass: '',
      newPass: '',
      newPass2: '',
      title: '密码修改'
    }
  },
  methods: {
    confirm() {
      this.loading = true
      const params = {
        username: this.operator.no,
        password: this.oldPass,
        newPassword: this.newPass2
      }
      post(api.adminAuthChangePassword, {}, params).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.saveSuccess'))
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>